<template>
  <validation-observer ref="simpleRules" >
    <b-form
      class="auth-forgot-password-form mt-2"
      @submit.prevent="validationForm"
    >
      <!-- email -->
      <b-form-group label="Email" label-for="forgot-password-email">
        <validation-provider
          #default="{ errors }"
          name="Email"
          rules="required|email"
        >
          <b-form-input
            id="forgot-password-email"
            v-model="userEmail"
            :state="errors.length > 0 ? false : null"
            name="forgot-password-email"
            autocomplete="on"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>

      <!-- submit button -->
      <b-button class="gradient-btn py-2" block type="submit" >
        Send reset link
      </b-button>
    </b-form>
    <loader :loading="loading" />
  </validation-observer>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { BLink, BFormGroup, BFormInput, BForm, BButton } from "bootstrap-vue";
import { required, email } from "@validations";
import Loader from "@/@core/components/loader/Loader.vue";

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BLink,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    Loader,
  },
  data() {
    return {
      userEmail: "",
      loading: false,
      // validation
      required,
      email,
    };
  },
  methods: {
    validationForm() {
      this.$refs.simpleRules.validate().then(async (success) => {
        if (success) {
          this.loading = true;
          try {
            await this.$http.post("auth/partner/forgot-password", {
              email: this.userEmail,
            });
            // this.$toast({
            //   component: ToastificationContent,
            //   props: {
            //     title: `Password Reset Link sent successfully`,
            //     icon: "CoffeeIcon",
            //     variant: "success",
            //   },
            // });
          } catch (err) {}
          this.loading = false;
        }
      });
    },
  },
};
</script>

<style></style>
